export const SYSTEM_RECEIPT = "/receipt";
export const SYSTEM_SIGN = "/sign";
export const SYSTEM_SCAN = "/scan";
export const SYSTEM_ACCESS_CONTROL = "/access-control";
export const SYSTEM_GATE = "/gate";
